
<div class="md:flex">
  <div class="inline-block w-256 mr-16">
    <h3 class="text-overline mb-4">Type</h3>
    <p class="text-body text-left mb-16">Regular sitter</p>
    <h3 class="text-overline mb-4">Start Date</h3>
    <p :class="`text-body text-left ${startDateFlexible ? '' : 'mb-16'}`">{{ formattedStartDate }}</p>
    <p v-if="startDateFlexible" id="start-date-flexible" class="text-body text-left mb-16 italic">Start date is flexible</p>
  </div>
  <div class="inline-block w-256 mb-16">
    <h3 class="text-overline mb-4">Days</h3>
    <p data-test-id="days" class="text-body text-left mb-16">{{ days.join(', ') }}</p>
    <h3 class="text-overline mb-4">Time</h3>
    <p data-test-id="time" class="text-body text-left">{{ timeFrame }}</p>
    <p data-test-id="duration" class="text-body text-left italic">Duration: {{ duration }}</p>
  </div>
</div>
